import { module } from 'angular';

import { default as scriptRedictionServiceName, ScriptRedirectionService } from './script-redirection.service';

export default module('contact.agent.core.phone.script-redirection', []).service(scriptRedictionServiceName, ScriptRedirectionService).name;
